module.exports = __webpack_public_path__ + "Intellectual-92207307b931c408a04bc49649f9064f.png";